/* Elevate product page controller: gallery, options, bundles, add to cart, shipping dates, sticky bar */
(function () {
  function money(cents, fmt) {
    var v = cents / 100;
    var sep = function (s, t) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, t); };
    var f = {
      amount: sep(v.toFixed(2).split('.')[0], ',') + '.' + v.toFixed(2).split('.')[1],
      amount_no_decimals: sep(String(Math.round(v)), ','),
      amount_with_comma_separator: sep(v.toFixed(2).split('.')[0], '.') + ',' + v.toFixed(2).split('.')[1],
      amount_no_decimals_with_comma_separator: sep(String(Math.round(v)), '.'),
      amount_with_space_separator: sep(v.toFixed(2).split('.')[0], ' ') + ',' + v.toFixed(2).split('.')[1]
    };
    return (fmt || 'R {{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) { return f[k] || f.amount; });
  }
  /* Like Shopify's money_without_trailing_zeros */
  function moneyShort(cents, fmt) {
    var s = money(cents, fmt);
    return cents % 100 === 0 ? s.replace(/[.,]00(?=\D*$)/, '') : s;
  }

  function addBusinessDays(n) {
    var d = new Date(); var c = 0;
    while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; }
    return d;
  }
  function fmtDate(d) { return d.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' }); }

  /* Unlock every add-to-cart button (used when the page is shown again, e.g. after pressing Back from checkout) */
  function resetButtons() {
    document.querySelectorAll('[data-es-atc].is-loading').forEach(function (b) { b.classList.remove('is-loading'); clearTimeout(b._esUnlock); });
  }
  window.addEventListener('pageshow', resetButtons);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') resetButtons(); });

  function setup(el) {
    if (el._esPdp) return;
    el._esPdp = true;
    var fmt = el.getAttribute('data-money');
    var state = { qty: 1, variant: el.getAttribute('data-variant'), total: null };

    /* Gallery */
    var slides = el.querySelector('[data-es-slides]');
    if (slides) {
      var n = slides.children.length;
      var thumbs = Array.prototype.slice.call(el.querySelectorAll('[data-es-thumb]'));
      var cur = el.querySelector('[data-es-cur]');
      var index = function () { return Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)); };
      var upd = function () { var i = index(); if (cur) cur.textContent = i + 1; thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); }); };
      slides.addEventListener('scroll', function () { clearTimeout(slides._t); slides._t = setTimeout(upd, 60); }, { passive: true });
      var go = function (i) { i = Math.max(0, Math.min(n - 1, i)); slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' }); };
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
      el.querySelectorAll('[data-es-nav]').forEach(function (b) { b.addEventListener('click', function () { go(index() + Number(b.getAttribute('data-es-nav'))); }); });
      upd();
    }

    /* Bundles */
    var opts = Array.prototype.slice.call(el.querySelectorAll('[data-es-bundle]'));
    var pick = function (o) {
      opts.forEach(function (x) { x.classList.toggle('is-active', x === o); var r = x.querySelector('input'); if (r) r.checked = x === o; });
      state.qty = Number(o.getAttribute('data-qty')) || 1;
      state.total = Number(o.getAttribute('data-total')) || null;
      state.gifts = (o.getAttribute('data-gifts') || '').split(',').filter(Boolean);
      el.querySelectorAll('[data-es-qty]').forEach(function (i) { i.value = state.qty; });
      el.querySelectorAll('[data-es-atc-price]').forEach(function (s) { s.textContent = state.total ? money(state.total, fmt) : ''; });
      /* Price under the title can mirror the chosen bundle (total + old price) */
      el.querySelectorAll('[data-es-follow-bundle]').forEach(function (pb) {
        var t = o.querySelector('[data-es-b-total]'), c = o.querySelector('[data-es-b-compare]');
        var now = pb.querySelector('[data-es-price-now]'), was = pb.querySelector('[data-es-price-compare]');
        if (t && now) now.textContent = t.textContent;
        if (c && was) { was.textContent = c.textContent; was.hidden = c.hidden; }
      });
      document.dispatchEvent(new CustomEvent('es:bundle-change', { detail: { qty: state.qty, total: state.total } }));
    };
    opts.forEach(function (o) { o.addEventListener('click', function () { pick(o); }); });
    var pre = opts.filter(function (o) { return o.classList.contains('is-active'); })[0] || opts[0];
    if (pre) pick(pre);

    /* Options (e.g. 50 / 100 tabs): update prices everywhere */
    var pills = Array.prototype.slice.call(el.querySelectorAll('[data-es-variant-id]'));
    var setVariant = function (id, price, compare, title) {
      state.variant = id;
      compare = Math.max(compare || price, price);
      pills.forEach(function (p) { var on = p.getAttribute('data-es-variant-id') === String(id); p.classList.toggle('is-active', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); });
      el.querySelectorAll('[data-es-variant-name]').forEach(function (n) { if (title) n.textContent = title; });
      el.querySelectorAll('[data-es-variant-input]').forEach(function (i) { i.value = id; });
      el.querySelectorAll('select[data-es-variant]').forEach(function (s) { s.value = id; });
      el.querySelectorAll('[data-es-price-now]').forEach(function (n) { n.textContent = money(price, fmt); });
      el.querySelectorAll('[data-es-price-compare]').forEach(function (n) { n.textContent = money(compare, fmt); n.hidden = !(compare > price); });
      el.querySelectorAll('[data-es-price-badge]').forEach(function (n) {
        var tpl = n.getAttribute('data-tpl') || '';
        var pct = compare > price ? Math.floor((compare - price) * 100 / compare) : 0;
        n.textContent = tpl.replace('[amount]', money(compare - price, fmt)).replace('[percent]', pct);
        n.hidden = !(compare > price);
      });
      opts.forEach(function (o) {
        var q = Number(o.getAttribute('data-qty')) || 1;
        var off = Number(o.getAttribute('data-off')) || 0;
        /* Some pack sizes have their own bundle discount (e.g. 100 Tabs) */
        var isAlt = o.hasAttribute('data-alt-variant') && o.getAttribute('data-alt-variant') === String(id);
        if (isAlt && o.hasAttribute('data-off-alt')) off = Number(o.getAttribute('data-off-alt')) || 0;
        var tot = price * q - off;
        var ct = compare * q;
        /* Optional fixed old price per option (and per second pack) */
        if (isAlt && o.getAttribute('data-was-alt')) ct = Number(o.getAttribute('data-was-alt'));
        else if (!isAlt && o.getAttribute('data-was')) ct = Number(o.getAttribute('data-was'));
        o.setAttribute('data-total', tot);
        var b = o.querySelector('[data-es-b-total]'); if (b) b.textContent = money(tot, fmt);
        var s = o.querySelector('[data-es-b-compare]'); if (s) { s.textContent = money(ct, fmt); s.hidden = !(ct > tot); }
        var sv = o.querySelector('[data-es-b-save]'); if (sv) { sv.textContent = 'Save ' + moneyShort(ct - tot, fmt); sv.hidden = !(ct > tot); }
      });
      var act = opts.filter(function (o) { return o.classList.contains('is-active'); })[0];
      if (act) pick(act);
    };
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        if (p.disabled) return;
        setVariant(p.getAttribute('data-es-variant-id'), Number(p.getAttribute('data-price')), Number(p.getAttribute('data-compare')), p.getAttribute('data-title'));
      });
    });
    el.querySelectorAll('select[data-es-variant]').forEach(function (s) { s.addEventListener('change', function () { state.variant = s.value; }); });

    /* Every variant of this product + every free gift its bundles can add */
    var ownIds = function () {
      var ids = {};
      var put = function (v) { v = Number(v); if (v) ids[v] = true; };
      put(el.getAttribute('data-variant')); put(state.variant);
      pills.forEach(function (p) { put(p.getAttribute('data-es-variant-id')); });
      el.querySelectorAll('select[data-es-variant] option, [data-es-variant-input]').forEach(function (o) { put(o.value); });
      opts.forEach(function (o) { (o.getAttribute('data-gifts') || '').split(',').forEach(put); });
      return ids;
    };
    /* Buy-now flow: replace this product's earlier choice (and its gifts) instead of piling on top of it */
    var clearOwn = function () {
      var ids = ownIds();
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var upd = {}, n = 0;
          (c.items || []).forEach(function (i) { if (ids[i.variant_id]) { upd[i.key] = 0; n++; } });
          if (!n) return;
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) });
        })
        .catch(function () {});
    };

    /* Add to cart */
    /* toCheckout: Buy it now always skips the cart and goes straight to checkout */
    var add = function (btn, toCheckout) {
      if (!btn || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      /* Safety net: never leave the button locked */
      clearTimeout(btn._esUnlock);
      btn._esUnlock = setTimeout(function () { btn.classList.remove('is-loading'); }, 8000);
      var done = function () { clearTimeout(btn._esUnlock); btn.classList.remove('is-loading'); };
      var drawer = document.querySelector('cart-drawer');
      var skip = toCheckout === true || el.getAttribute('data-skip-cart') === 'true';
      var body = { items: [{ id: Number(state.variant), quantity: state.qty }] };
      /* Free gifts that come with the selected bundle (made free by a Buy X get Y discount) */
      (state.gifts || []).forEach(function (g) { body.items.push({ id: Number(g), quantity: 1, properties: { _gift: 'Free gift' } }); });
      /* Ask for the cart drawer HTML even if the drawer script hasn't finished loading yet (fast taps right after page load) */
      if (drawer && !skip) {
        body.sections = typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      (skip ? clearOwn() : Promise.resolve())
        .then(function () {
          return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok || res.d.status) { done(); alert(res.d.description || res.d.message || 'Sorry, this could not be added to your cart.'); if (window.esRefreshCart) window.esRefreshCart(); return; }
          if (skip) { window.location.href = '/checkout'; return; }
          if (drawer && res.d.sections) {
            var show = function () {
              drawer.classList.remove('is-empty');
              var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
              res.d.id = state.variant;
              drawer.renderContents(res.d);
              done();
            };
            if (typeof drawer.renderContents === 'function') show(); else customElements.whenDefined('cart-drawer').then(show);
          } else { window.location.href = '/cart'; }
        })
        .catch(function () { done(); window.location.href = '/cart'; });
    };
    el.querySelectorAll('[data-es-atc]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); add(b); }); });
    el.querySelectorAll('[data-es-buynow]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); add(b, true); }); });
    el.querySelectorAll('form[data-es-form]').forEach(function (f) { f.addEventListener('submit', function (e) { e.preventDefault(); add(f.querySelector('[data-es-atc]')); }); });

    /* Copy discount code */
    el.querySelectorAll('[data-es-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-es-copy'));
        b.classList.add('is-copied'); setTimeout(function () { b.classList.remove('is-copied'); }, 1600);
      });
    });

    /* Shipping timeline dates */
    el.querySelectorAll('[data-es-ship]').forEach(function (s) {
      var g = function (k) { return Number(s.getAttribute('data-' + k)) || 0; };
      var o = s.querySelector('[data-d="order"]'); if (o) o.textContent = fmtDate(new Date());
      var sh = s.querySelector('[data-d="ship"]'); if (sh) sh.textContent = fmtDate(addBusinessDays(g('s1'))) + (g('s2') > g('s1') ? ' – ' + fmtDate(addBusinessDays(g('s2'))) : '');
      var dl = s.querySelector('[data-d="del"]'); if (dl) dl.textContent = fmtDate(addBusinessDays(g('d1'))) + (g('d2') > g('d1') ? ' – ' + fmtDate(addBusinessDays(g('d2'))) : '');
    });

    /* Sticky add-to-cart bar: on phones it shows from page load until the real button is on screen, so a buy button is always above the fold */
    var sticky = el.querySelector('[data-es-pdp-sticky]');
    var buy = el.querySelector('[data-es-buy]');
    var phone = window.matchMedia('(max-width: 749px)');
    if (sticky && buy && 'IntersectionObserver' in window) {
      /* Show it straight away on phones instead of waiting for the first observer callback */
      if (phone.matches && buy.getBoundingClientRect().top > window.innerHeight) sticky.classList.add('is-on');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var nearEnd = window.innerHeight + window.scrollY >= document.body.scrollHeight - 300;
        var past = e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', !e.isIntersecting && (past || phone.matches) && !nearEnd);
      }).observe(buy);
      window.addEventListener('scroll', function () {
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 300) sticky.classList.remove('is-on');
      }, { passive: true });
    }
  }

  function init(root) { (root || document).querySelectorAll('[data-es-pdp]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
